import CountUp from "react-countup";
import { motion } from "framer-motion";

const stats = [
  { value: 480, suffix: "K+", label: "Tonnes lifted offshore" },
  { value: 1200000, suffix: "", label: "Man-hours worked", display: "1.2M+" },
  { value: 0, suffix: "", label: "Lost-time incidents · 2024", display: "0" },
  { value: 22, suffix: "", label: "Years on the water" },
];

export const Stats = () => (
  <section
    data-testid="stats-section"
    className="w-full px-6 md:px-12 py-20 md:py-28 border-t border-white/10"
  >
    <div className="grid grid-cols-1 md:grid-cols-4 border-t border-l border-white/10">
      {stats.map((s, i) => (
        <motion.div
          key={s.label}
          data-testid={`stat-${i}`}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: i * 0.1 }}
          className="border-b border-r border-white/10 p-8 md:p-10"
        >
          <div className="font-display text-5xl md:text-7xl tracking-tight text-white leading-none mb-4">
            {s.display ? (
              s.display
            ) : (
              <>
                <CountUp end={s.value} duration={2.4} enableScrollSpy scrollSpyOnce separator="," />
                {s.suffix}
              </>
            )}
          </div>
          <p className="font-mono text-xs tracking-[0.15em] uppercase text-[#94A3B8]">
            {s.label}
          </p>
        </motion.div>
      ))}
    </div>
  </section>
);
